import { CommandLifeCycleEvent, ICommand, ICommandHost } from './command/command.models';




export interface ITaskWrapper {
    task: TaskInfo
}

export declare type ITaskCommandWrapper = ICommand & ITaskWrapper
export interface TaskInfo {
    id?: string;
    name?: string;
    displayName?: string;
    description?: string;
    icon: string;
    commandId?: string,
    condition?: string,
    successfulCondition?: string;
    order?: number;
    rawPayload?: any;
    executionTime?: TaskExecutionTime,
    contextData?: { [key: string]: any },
    isAsync?: boolean;
    allowReset?: boolean;
    executionData?: TaskInfoExecutionData;
    notification?: TaskNotification;
}

export interface TaskNotification {
    command: string;
    level: string,
    header: string;
    icon: string;
    details: string,
    dismissible: boolean
    sourceCommand: ITaskCommandWrapper;
}

export interface TaskInfoExecutionData {

    status: TaskInfoStatus;
    previousStatus: TaskInfoStatus;
    evaluation: TaskInfoRunnableEvaluation;
    previousEvaluation: TaskInfoRunnableEvaluation;
    executionOrder: number;
    dismissedNotification: boolean;
    metadata: any;
}

export interface TaskInfoStatus {
    value: CommandLifeCycleEvent;
    date: Date;
}
export interface TaskInfoRunnableEvaluation {
    successful?: boolean;
    value: boolean;
    date: Date;
}

export enum TaskExecutionTime{
    Start = 'start',
    End = 'end'
};



export interface IMemberGuardAnswers {
    reason: MemberGuardAnswersReason;
}

export declare type MemberGuardAnswersReason = 'OnCall' | 'Management';
export interface ITaskHost extends ICommandHost {

}

export interface ITaskAdapter {

    cancelCommandConfig(): Promise<any>;
    closeTask(task: string);

}




